const PERMISSION_CONSTANTS = Object.freeze({
  USER_PERMISSIONS: "userPermissions",
});

const MODULE = Object.freeze({
  PERMISSIONS: "permissions",
});

const ACTION = Object.freeze({
  /*  Users Permissions */
  PERMISSIONS_CREATE: "permissions_create",
  PERMISSIONS_READ: "permissions_read",
  PERMISSIONS_UPDATE: "permissions_update",
  PERMISSIONS_DELETE: "permissions_delete",
});

export { PERMISSION_CONSTANTS, MODULE, ACTION };
